
<div class="chart">
  <h3 v-if="showTitle">Participants by Gender</h3>
  <loading-spinner v-if="loading" />
  <canvas ref="canvas" />
</div>
